import { Paper, Title, Badge, Loader, Center, Text } from '@mantine/core';
import { DataTable } from 'mantine-datatable';
import { usePodStatus } from './usePrometheus';

export function PodStatusTable() {
  const { data: pods, isLoading, error } = usePodStatus();

  if (error) {
    return (
      <Paper shadow="xs" p="md" withBorder>
        <Title order={4} mb="md">Pods</Title>
        <Text c="red">Fehler beim Laden: {String(error)}</Text>
      </Paper>
    );
  }

  if (isLoading || !pods) {
    return (
      <Paper shadow="xs" p="md" withBorder>
        <Title order={4} mb="md">Pods</Title>
        <Center><Loader size="sm" /></Center>
      </Paper>
    );
  }

  const sorted = [...pods].sort((a, b) => a.pod.localeCompare(b.pod));

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Title order={4} mb="md">Pods ({pods.length})</Title>
      <DataTable
        height={400}
        withTableBorder
        striped
        highlightOnHover
        records={sorted}
        idAccessor="pod"
        columns={[
          { accessor: 'pod', title: 'Pod', width: '45%' },
          {
            accessor: 'phase',
            title: 'Status',
            width: '15%',
            render: (row) => (
              <Badge
                color={row.phase === 'Running' ? 'green' : row.phase === 'Pending' ? 'yellow' : 'red'}
                variant="light"
                size="sm"
              >
                {row.phase}
              </Badge>
            ),
          },
          {
            accessor: 'ready',
            title: 'Ready',
            width: '15%',
            render: (row) => (
              <Badge color={row.ready ? 'green' : 'red'} variant="dot" size="sm">
                {row.ready ? 'Yes' : 'No'}
              </Badge>
            ),
          },
          {
            accessor: 'restarts',
            title: 'Restarts',
            width: '15%',
            render: (row) => (
              <Badge color={row.restarts > 5 ? 'red' : row.restarts > 0 ? 'yellow' : 'gray'} variant="light" size="sm">
                {row.restarts}
              </Badge>
            ),
          },
        ]}
      />
    </Paper>
  );
}
